import React, { useContext, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

const ChartsReceived = ({ getRows }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport, verifySort } = getItensStateGlobal;
  const endpointsReceiveds = storageDataReport.endpointsReceiveds || {};

  const chartCallsReceivedRef = useRef(null);

  const getDataToRequestFilter = (event) => {
    if (chartCallsReceivedRef.current) {
    const chart = ChartJS.getChart(chartCallsReceivedRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];
      const endpointId = labelToEndpointId[labelIndexClicked] || '';

      labelType === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';
      getRows('endpoints-receiveds', endpointId, labelType);
    }
   }
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  

  const labelToEndpointId = {};
  const renamedEndpoints = Object.keys(endpointsReceiveds).reduce((acc, cur) => {
    const item = endpointsReceiveds[cur];
    if (item && item.name != null) {
      const display = item.name;
      acc[display] = { atendidas: item.atendidas ?? 0, perdidas: item.perdidas ?? 0 };
      labelToEndpointId[display] = cur;
    }
    return acc;
  }, {});

  const labels = Object.keys(renamedEndpoints);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Atendidas',
        // data: labels.map((label) => endpointsReceiveds[label].atendidas),
        data: labels.map((label) => (renamedEndpoints[label] && renamedEndpoints[label].atendidas) ?? 0),
        backgroundColor: 'rgba(30, 144, 255, 0.8)',
        borderColor: 'rgb(30, 144, 255, 0, 0.8)',
        datalabels: {
          align: 'top'
        },
      },
      {
        label: 'Não Atendidas',
        // data: labels.map((label) => endpointsReceiveds[label].perdidas),
        data: labels.map((label) => (renamedEndpoints[label] && renamedEndpoints[label].perdidas) ?? 0),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        datalabels: {
          align: 'top'
        },
      },
    ],
  };
  
  return (
    <div className="column is-half">
      <h2 className="has-text-centered is-size-5">Chamadas Recebidas por Ramal</h2>
        <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={chartCallsReceivedRef} getElementAtEvent={(_, event) => getDataToRequestFilter(event)} />
    </div>
  );
}

export default ChartsReceived;
